export function getWidgetVisibilityLogicPermittedList() {
    var _a, _b, _c;
    return Object.values(((_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.CVENT) === null || _a === void 0 ? void 0 : _a.experiments) === null || _b === void 0 ? void 0 : _b.flex_widget_visibility_logic) === null || _c === void 0 ? void 0 : _c.permittedList) || {});
}
